import { useAuthAppStore } from "@/store/stores/authStore";
import { ErrorMessageService } from "@/services/errorMessageService/errorMessageService";

export class ProductService {
  async getAllEntityByPKey({ productManagementServiceClient, params }) {
    var paramsBase = {
      PKey: params.PKey,
    };

    var response = await productManagementServiceClient.get({
      route: "/product/get-entity-by-pkey",
      params: paramsBase,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getAllEntitiesPaged({ productManagementServiceClient, params }) {
    var paramsBase = {
      take: 100,
      skip: 0,
      filter: ["ProductCatalogPkey", "contains", params.selectedProductCatalog],
    };

    var response = await productManagementServiceClient.get({
      route: "/product/get-all-entities-paged",
      params: paramsBase,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async setExport(filters, cproxServiceClient) {
    try {
      const response = await cproxServiceClient.product.post({
        data: {
          Filters: filters,
        },
        route: "/product/download-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      } else {
        throw new Error("Invalid response from ContainerService");
      }
    } catch (error) {
      if (error.isAxiosError) {
        this._sweetAlertService.showAlert(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            ),
          "error"
        );
      } else {
        console.error("Unexpected error from import-entities-with-file", error);
        throw error;
      }
    }
  }

  async setImport(
    file,
    deleteNotInFile,
    cproxServiceClient,
    fileManagerService
  ) {
    try {
      const convertedFile = await fileManagerService.convertToByteArray(file);

      const response = await cproxServiceClient.product.post({
        data: {
          File: JSON.stringify(Array.from(convertedFile)),
          DeleteNotInFile: deleteNotInFile,
        },
        route: "/product/import-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      } else {
        throw new Error("Invalid response from ContainerService");
      }
    } catch (error) {
      if (error.isAxiosError) {
        this._sweetAlertService.showAlert(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            ),
          "error"
        );
      } else {
        console.error("Unexpected error from import-entities-with-file", error);
        throw error;
      }
    }
  }

  async getProductListByProductCatalogPKey({
    productManagementServiceClient,
    params,
  }) {
    var paramsBase = {
      ProductCatalogPKey: params.selectedProductCatalog,
    };

    var response = await productManagementServiceClient.get({
      route: "/product/GetProductListByProductCatalogPKey",
      params: paramsBase,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }
}
